import React, { useState } from "react";
import ProgressBar from "../Common/ProgressBar";
import RadioButton from "../../../UI/RadioButton";
const StillActive = ({ className, slideChange, textHeading, validation }) => {
  const [checkedQuestionOne, setCheckedQuestionOne] = useState("unchecked");
  const [checkedQuestionTwo, setCheckedQuestionTwo] = useState("unchecked");
  const nextSlide = async (e) => {
    if (e.target.value === "95") {
      setCheckedQuestionOne("checked");
      setCheckedQuestionTwo("unchecked");
      slideChange(e);
    }
    if (e.target.value === "96") {
      setCheckedQuestionOne("unchecked");
      setCheckedQuestionTwo("checked");
      slideChange(e);
    }
  };
  return (
    <>
      <div id="slide-1" className={`${className}`}>
        <ProgressBar value="0" />

        <h3> {textHeading} </h3>
        <div className="radio_buttons">
          <RadioButton
            value="95"
            name="stillactive"
            className="radio regNextBtn"
            labelName="Yes"
            labelClassName={`radio ${checkedQuestionOne}`}
            onClick={nextSlide}
            validation={validation()}
          />

          <RadioButton
            value="96"
            name="stillactive"
            className="radio regNextBtn"
            labelName="No"
            labelClassName={`radio ${checkedQuestionTwo}`}
            onClick={nextSlide}
            validation={validation()}
          />
        </div>
      </div>
    </>
  );
};
export default StillActive;
